import { FC } from 'react';
import { HStack, Text } from '@chakra-ui/react';

type StatusLabelProps = {
  label: string;
};

export const StatusLabel: FC<StatusLabelProps> = ({
  label,
  children,
  ...rest
}) => (
  <HStack spacing={4} {...rest}>
    <Text color="gray.500" size="xs">
      {label}
    </Text>
    {children}
  </HStack>
);
